module.exports = __webpack_public_path__ + "static/media/word_shop.88f8861c.svg";